// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__FwGPX","shadow324":"spinner_shadow324__UiK6l","jump7456":"spinner_jump7456__epw4G"};